import { readJson, remove, writeJson } from "./storage";

// Unfinished, never-submitted step state (a counting estimate, ink not yet
// handed in, a draft paragraph) kept on this tablet only so a refresh returns
// to it. It is never a learner submission and never reaches the gateway: the
// submission history holds only what the learner handed in (Learner Work
// Policy v1 §4). A tablet belongs to one learner; Reset tablet clears it.

const KEY = "runtime";
// A page of simplified ink is the largest thing kept; stay well inside quota.
const MAX_BYTES = 256 * 1024;

const all = () => readJson(KEY, {});

export const readRuntime = (attemptId, stepId) =>
  (attemptId && all()[attemptId]?.[stepId]) || null;

export const writeRuntime = (attemptId, stepId, value) => {
  if (!attemptId) return false;
  const store = all();
  store[attemptId] = { ...(store[attemptId] || {}), [stepId]: value };
  if (JSON.stringify(store).length > MAX_BYTES) return false;
  return writeJson(KEY, store);
};

export const clearRuntimeStep = (attemptId, stepId) => {
  const store = all();
  if (!store[attemptId]?.[stepId]) return;
  delete store[attemptId][stepId];
  if (!Object.keys(store[attemptId]).length) delete store[attemptId];
  writeJson(KEY, store);
};

export const clearAllRuntime = () => remove(KEY);
